import { LinearProgress } from "@mui/material";
import FormikInputLabel from "components/disw/FormikInputLabel";
import { useInputLabelStyles } from "components/disw/InputLabelStyle";
import { SelectBox } from "devextreme-react";
import { ValueChangedEvent } from "devextreme/ui/select_box";
import { useStyles } from "./FiltersComponentsStyle";

type SelectBoxProps<TValue> = {
  items: TValue[];
  displayExpr: string | ((item: TValue) => string);
  valueExpr: string | ((item: TValue) => string | number | boolean) | undefined;
  value?: string;
  onValueChanged: (e: ValueChangedEvent) => void;
  placeholder?: string;
  label: string;
  loading?: boolean;
  required?: boolean;
  isError?: boolean;
  errorText?: string;
};

export default function SelectComboBox<TValue>(props: SelectBoxProps<TValue>) {
  const classNames = useStyles();
  const labelClasses = useInputLabelStyles();
  const {
    items,
    displayExpr,
    valueExpr,
    value,
    onValueChanged,
    placeholder,
    label,
    loading,
    required,
    isError,
    errorText
  } = props;
  return (
    <div className={classNames.selectBoxWrapper}>
      <div className={classNames.indicatorWrapper}>
        {loading && <LinearProgress />}
      </div>
      <FormikInputLabel
        name={label}
        required={required}
        label={label}
        isError={isError}
        errorMessage={errorText}
        labelClasses={{
          ...labelClasses,
          errorText: classNames.errorText,
          labelFlex: classNames.labelFlex
        }}
      />
      <div>
        <SelectBox
          items={items}
          displayExpr={displayExpr}
          valueExpr={valueExpr}
          value={value}
          onValueChanged={onValueChanged}
          className={
            isError ? classNames.selectBoxWithError : classNames.selectBox
          }
          dropDownOptions={{
            wrapperAttr: { class: classNames.dropdownlist }
          }}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}
